import { render, staticRenderFns } from "./onboard.vue?vue&type=template&id=c6bb82a6"
import script from "./onboard.vue?vue&type=script&lang=js"
export * from "./onboard.vue?vue&type=script&lang=js"
import style0 from "./onboard.vue?vue&type=style&index=0&id=c6bb82a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports